import classNames from 'clsx';
import type CSS from 'csstype';
import React from 'react';

import type { Heading, Html } from '@swf/cms';
import { CMSHTML, CMSHeading } from '@swf/cms';

import styles from './CMSPageSection.scss';

export interface Props {
  heading?: Heading;
  intro?: Html;
  children?: React.ReactNode;
  contain?: boolean;
  grid?: boolean;
  columns?: Nullable<number>;
  className?: string;
  gridClassName?: string;
  style?: CSS.Properties;
  gridStyle?: CSS.Properties;
}

const CMSPageSection: React.FC<Props> = ({
  heading,
  intro,
  children,
  contain = true,
  grid = false,
  columns,
  className,
  style,
  gridClassName,
  gridStyle
}) => (
  <div className={className} style={style}>
    {(heading?.title || intro?.content) && (
      <div className={classNames(styles.header, { [styles.contain]: contain })}>
        {heading && <CMSHeading {...heading} />}
        {intro && <CMSHTML {...intro} />}
      </div>
    )}
    {!!children && (
      <div
        className={classNames(columns && styles[`col${columns}`], gridClassName, {
          [styles.contain]: contain,
          [styles.grid]: grid
        })}
        style={gridStyle}
      >
        {children}
      </div>
    )}
  </div>
);
export default CMSPageSection;
